<template>
  <div class="container">
    <el-row :gutter="10">
      <el-col :span="13">
        <filterWrapper :filter-item="{canteen:true, eatery: true, dateRange: true}">
        </filterWrapper>
      </el-col>
      <el-col :span="3">
        <div class="btn-wrapper">
          <el-button type="primary" @click="getBackData">查询</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <h3>来源: </h3>
    </el-row>
    <el-row :gutter="10" v-if="currentDishModel">
      <el-col :span="14">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>名称: {{currentDishModel.dish_name}}</span>
            <div class="btn-wrapper-1">
              <el-button type="primary" :disabled="currentIndex < 1"  @click="preDishModel">上一个例图</el-button>
              <el-button type="primary" :disabled="currentIndex === currentDishModel.length - 1"
                         @click="nextDishModel">下一个例图
              </el-button>
            </div>
          </div>
          <el-col :span="4">
            <el-badge value="01" class="item">
              <img :src="currentDishModel.dish_image_url" width="150" alt="">
            </el-badge>
          </el-col>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import filterWrapper from '_c/filterWrapper';
import {mapGetters, mapActions, mapMutations} from 'vuex';
import util from '@/lib/util';
import {apiGetBackData} from '@/api';

export default {
  name: '',
  components: {
    filterWrapper
  },
  data () {
    return {
      currentIndex: 0
    };
  },
  mounted () {
    this.setSubTitle('回测数据准确率');
  },
  methods: {
    ...mapMutations([
      'setSubTitle'
    ]),
    nextDishModel () {
      if (this.currentIndex < this.modelList.length) {
        this.currentIndex++;
      }
    },
    // 上一个例图
    preDishModel () {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    getBackData () {
      apiGetBackData({
        canteenId: this.listQuery.canteen.canteen_id,
        dateRange: {
          start_ts: util.dateToUnixtimestamp(this.listQuery.dateRange[0], 0),
          end_ts: util.dateToUnixtimestamp(this.listQuery.dateRange[1], 1)
        }
      }).then(res => {
        console.log(`ssssssssssssssssssss`, res);
        if (res.state_code === 0) {
          console.log(Object.keys(res.data));
          this.backData = res.data;
          this.batchOptions = Object.keys(this.backData);
          this.dataFilter.batch = this.batchOptions[0];
        } else {
          return Promise.reject(res.error_msg);
        }
      })
        .catch(e => {
        });
    }
  },
  computed: {
    ...mapGetters([
      'modelList',
      'listQuery',
      'userinfo'
    ]),
    apiKey () {
      return this.userinfo().api_key;
    },
    currentDishModel () {
      return this.modelList[this.currentIndex];
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .btn-wrapper {
    margin-top: 5px;
  }
  .box-card {
    .btn-wrapper-1 {
      display: inline-block;
      float: right;
      margin-top: -10px;
    }
  }
}

</style>
